/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getAccountPage = (): Layout => ({
	name: 'MyPages',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		aside: [],
		second: [],
		third: [{ name: 'Account', id: 'account' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
